import { render, staticRenderFns } from "./table_detail.vue?vue&type=template&id=25ff4b1b&scoped=true"
import script from "./table_detail.vue?vue&type=script&lang=js"
export * from "./table_detail.vue?vue&type=script&lang=js"
import style0 from "./table_detail.vue?vue&type=style&index=0&id=25ff4b1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff4b1b",
  null
  
)

export default component.exports